<template>
  <div class="form-group">
    <label>{{$t('catalogCateg.vat')}}</label>
    <small>({{$t('catalogCateg.included')}})</small>
    <select
      v-model="output"
      class="form-control"
      @input="handleClick()"
      v-validate="{required: true}">
      <option 
        v-for="vat in vatOptions"
        :value="vat.amount"
      >{{ vat.amount }}
      </option>
    </select>
    <!-- <small class="text-danger" v-if="errors.has(tax_rate.hash_id)">
      {{ getError(tax_rate.hash_id) }}
    </small> -->
  </div>
</template>
<script>
  import Vue from 'vue'

  export default{
    name: 'vat-dropdown',
    props: {
      locationIds: {
        type: Array
      },
      vatValue: {
        type: Number
      }
    },
    data () {
      return {
        output: '',
        vatOptions: [],
        vatInputValue: ''
      }
    },
    beforeCreated () {
      this.output = this.vatInputValue ? this.vatInputValue : null
      this.getData()
    },
    watch: {
      locationIds (value) {
        this.locationIds = value
        this.getData()
      },
      vatValue (value) {
        Vue.set(this, 'vatInputValue', value)
      }
    },
    methods: {
      getData () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          location_ids: this.locaitonIds
        }
        this.apiRequest('/location/vat', 'GET', data, (response) => {
          if (response.status === true) {
            this.vatOptions = response.data
          }
        })
      },
      handleClick () {
        this.$emit('vat-change', this.output)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Inputs/VatDropdown.vue